import { useMutation, useQueryClient } from "@tanstack/react-query";
import { revinoTargetareSnapshot } from "@/api/endpoints/targetareDate";
import { queryKeys } from "@/lib/queryClient";

export function useRevinoTargetareSnapshot() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: revinoTargetareSnapshot,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.snapshoturi(),
      });
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.stats() });
    },
  });
}
